import { mergeDeepRight, map } from 'ramda'

export default class FunnelSettingsSaveModel {
  constructor(funnelSettings, customDomain) {
    this.Settings = extractSettings({ funnelSettings })
    this.BusinessUnitFunnel = new BusinessUnitFunnelApiModel(funnelSettings)
    this.CustomDomain = customDomain ? { DomainName: customDomain } : null
  }
}

export function extractSettings({ funnelSettings }) {
  const obj = mergeDeepRight(funnelSettings, {})
  return map(key => ({
    SettingKey: key,
    Values: obj[key] ? [obj[key]] : [],
  }))(['BrandingLogoUrl', 'EmailCompanyUrl', 'EmailTermsAndConditionsUrl', 'MerchantPrivacyPolicy'])
}

class BusinessUnitFunnelApiModel {
  constructor(funnelSettings) {
    this.Tagline = funnelSettings.Tagline
    this.Usps = funnelSettings.Usps
    this.TagManagerId = funnelSettings.TagManagerId
    this.FacebookDomainVerificationId = funnelSettings.FacebookDomainVerificationId
    this.FacebookRating = funnelSettings.FacebookRating
    this.TripadvisorRating = funnelSettings.TripadvisorRating
    this.TranslationInfo = funnelSettings.TranslationInfo
  }
}
